// ✅ Admin.jsx (Chakra 제거 + Ant Design 기반)
import BasicLayout from '@/components/common/layout/basic';
import { Typography } from 'antd';

const { Title } = Typography;

function Admin() {
  return (
    <BasicLayout>
      {/* body_classname="bg-gray-1" */}
      <Title level={1}>산정 프로젝트 관리</Title>
    </BasicLayout>
  );
}

export default Admin;
